import React from 'react';
import styled from 'styled-components';
import { ClaroModalCustom, ClaroCardSimple} from "@claropay/shared";
import { getImageCard } from "../utils/index";
import { getExpirationDate } from '../../GenericForm/utils/getExpirationDate'
import { CREDIT_CLARO_PAY, ADVANCEMENT_CLARO_PAY } from '../../../../constants';
import { ClaroSDKService } from '../../../../services/sdk/ClaroSDKService';
import CarouselMegasTelcel from '../../CarouselMegasTelcel';
import { getServicesTelcel }  from '../../utils';

const Title = styled.div`
    color: ${props => props.fontColor ? props.fontColor : "#000"};
    text-align: center;
    font-weight: ${props => props.fontWeight ? props.fontWeight : "bold"};
    margin: 0% 0%;
    padding: 0% 0%;
    font-family: ${props => props.fontFamily ? props.fontFamily : "Nunito"};
    font-size: ${props => props.fontSize ? props.fontSize : "inherit"};
`;
const Option = styled.div`
    color: ${props => props.fontColor ? props.fontColor : "#000"};
    padding: ${props => props.padding ? props.padding : "3% 2% 3% 2%"};
    box-shadow: ${props => props.boxShadow ? props.boxShadow : "0px 0px 5px 1px rgba(0, 0, 0, .1)"}; 
    border: ${props => props.border ? props.border : "1px solid rgb(0, 0, 0, .1)"};
    border-radius: ${props => props.borderRadius ? props.borderRadius : "3px"};
    margin-bottom: ${props => props.marginBottom ? props.marginBottom : "7%"};
    margin-left: 0%;
    margin-right: 0%;
    margin-top: 0%;
    font-family: ${props => props.fontFamily ? props.fontFamily : "roboto"};
    font-size: ${props => props.fontSize ? props.fontSize : "inherit"};
    background: #fff;
`;

const TextOption = styled.p`
    color: #000;
    font-size: 12px;
    font-weight: normal;
    display: inline;
    vertical-align: "middle";
    padding: ${props => props.padding ? props.padding : "0% 0% 0% 0%"};
`;


const ButtonClose = styled.div`
    text-align: right;
    display: block;
    width: 100%;
`;

function SelectCardClaroSocio(props) {
    let arrayItems = [];

    const {isClaroPartner, isContainerTelcel} = props;
    
    const cardInfoItemClaroPay = {
        value: "claro-pay",
        mark : "999",
        type :  0,
        lastDigits : " ",
        update: false
    };

    const cardCreditClaroPay ={
        value: CREDIT_CLARO_PAY,
        mark : "997",
        type :  0,
        lastDigits : " ",
        update: false
    }

    const cardAdvancementClaroPay ={
        value: ADVANCEMENT_CLARO_PAY,
        mark : "996",
        type :  0,
        lastDigits : " ",
        update: false
    }

    const cardInfoItemAddCard = {
        value: "agregar-targeta",
        id: "agregar-targeta"
    }

    let paymentMethodBulletInactive = isContainerTelcel ? "/images/check_card_inactive_contenedor.png" : "/images/icono_seleccion_inactivo.svg";
    let paymentMethodBulletActive = isContainerTelcel ? "/images/check_card_active_contenedor.png" : "/images/icono_seleccion_activo.svg";
    if (props.isClaroPartner) {
        paymentMethodBulletInactive = "/images/icono_icono_seleccion_activo.png"
    }

    const handleOpenOnBoarding = () => {
        setTimeout(() => {
            ClaroSDKService.openOnBoarding()
        }, 500);
    }

    const handleExecuteTaggeo = (action) => {
        if (action === "Click modal Cerrar" && props.canMultiAnalytics && props.isContainerTelcel) {
            const originAnalyticArray = props.originAnalytic? props.originAnalytic.split(",") : [];
            props.executeTaggeo({
                eventName: "pay_service_or_tae",
                seccion: "servicios",
                subseccion: props.serviceInfo && props.serviceInfo.serviceId && getServicesTelcel(props.serviceInfo.serviceId),
                origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
                pantalla: "formulario de pago",
                nombreServicio: props.serviceInfo && props.serviceInfo.serviceName ? props.serviceInfo.serviceName : props.serviceInfo.categoryName,
                tipoElemento: "card",
                nombreElemento: "cerrar",
                trackAction: true,
            });					 
        }      
    }

    if (isContainerTelcel && !props.hasN2) {
        arrayItems.push(
            <CarouselMegasTelcel
            origin={"SelectPaymentMethod"}
            margin={"0px 0px 20px 0px" }
            handleInputClick={() => props.closeSelectCardClaroSocio()}
            handleBannerClick={(evt,bannerImageURL) => {
                const { executeTaggeo } = props;
                executeTaggeo({
                    eventName: "pay_service_or_tae",
                    step: "Formulario de pago",
                    action: "Click banner",
                    banner_id: bannerImageURL,
                    id_message: "Elige método de pago"
                });
            }} />
        )
    }

    if(!isContainerTelcel && props.showAdvancementPayMethodInList){
        arrayItems.push(<Option 
            fontColor = {isContainerTelcel ? "#222222" : undefined}
            fontFamily = {isContainerTelcel ? "AMX-Regular" : "Roboto"} 
            borderRadius={isContainerTelcel ? "4px" : undefined} 
            boxShadow={isContainerTelcel ? "0px 2px 2px 0px #c6c6c6, 0px 2px 2px #fafafa" : undefined} 
            padding={isContainerTelcel ? "18.6px 15.1px 16.2px 13.6px" : undefined} 
            key={996} 
            onClick={(event) => props.handleInputClick(event, "cardId", cardAdvancementClaroPay)}
            border={(props.selectValue == CREDIT_CLARO_PAY && props.isClaroPartner) ? "1.5px solid #369cf7" : null}
            role='button'
            aria-label='Seleccionar pagar con adelanto claropay'
        >
        <img
            style={{ height: '24px', marginRight: "3%", verticalAlign: "middle" }}
            src={"/images/adelanto.png"}
            alt=''
        />
         <img
            style={{ width: isContainerTelcel ? '19.2px' : '24px', height: isContainerTelcel ? '19.2px' : '24px', verticalAlign: "middle", float: "right", position: 'relative', top: isContainerTelcel ? '4px' : '0px'}}
            src={(props.selectValue == ADVANCEMENT_CLARO_PAY)?paymentMethodBulletActive:paymentMethodBulletInactive}
            alt=''
        />
        </Option>
        );
    }

    if(props.isCreditPay){
        arrayItems.push(<Option 
            fontColor = {isContainerTelcel ? "#222222" : undefined}
            fontFamily = {isContainerTelcel ? "AMX-Regular" : undefined} 
            borderRadius={isContainerTelcel ? "4px" : undefined} 
            boxShadow={isContainerTelcel ? "0px 2px 2px 0px #c6c6c6, 0px 2px 2px #fafafa" : undefined} 
            padding={isContainerTelcel ? "18.6px 15.1px 16.2px 13.6px" : undefined} 
            key={997} 
            onClick={(event) => props.handleInputClick(event, "cardId", cardCreditClaroPay)}
            border={(props.selectValue == CREDIT_CLARO_PAY && props.isClaroPartner) ? "1.5px solid #369cf7" : null}
            role='button'
            aria-label='Seleccionar pagar con crédito claro pay'
        >
        <img
            style={{ height: '24px', marginRight: "3%", width: "12%", verticalAlign: "middle" }}
            src={"/images/tarjetaClaropayCredito.png"}
            alt=''
        />
        <TextOption style={{color:"#7f7d7f", fontSize:"13px"}}>{ "Crédito" }</TextOption>
        <img
            style={{ height: '20px', marginBottom: '-3px', marginLeft: '5px' }}
            src={"/images/logo_tarjeta_claro_pay_no_inbursa.png"}
            alt=''
        />
         <img
            style={{ width: isContainerTelcel ? '19.2px' : '24px', height: isContainerTelcel ? '19.2px' : '24px', verticalAlign: "middle", float: "right", position: 'relative', top: isContainerTelcel ? '4px' : '0px'}}
            src={(props.selectValue == CREDIT_CLARO_PAY)?paymentMethodBulletActive:paymentMethodBulletInactive}
        />
        </Option>
        );
    }

    if(props.hasN2 && props.activeN2){
        arrayItems.push(<Option             
            border={(props.selectValue == "claro-pay" && props.isClaroPartner) ? "1.5px solid #369cf7" : null}
            fontColor = {isContainerTelcel ? "#222222" : undefined}
            fontFamily = {isContainerTelcel ? "AMX-Regular" : undefined} 
            borderRadius={isContainerTelcel ? "4px" : undefined} 
            boxShadow={isContainerTelcel ? "0px 2px 2px 0px #c6c6c6, 0px 2px 2px #fafafa" : undefined} 
            padding={isContainerTelcel ? "18.6px 15.1px 16.2px 13.6px" : undefined} 
            key={999} 
            onClick={(event) => {
                props.handleInputClick(event, "cardId", cardInfoItemClaroPay)
            }}
            role='button'
            aria-label='Seleccionar pagar con claro pay'
        >
            {
                !isContainerTelcel ?
                <>
                    <img
                        style={{ height: '24px', marginRight: "3%", width: "12%", verticalAlign: "middle" }}
                        src={"/images/claroPay.png"}
                        alt=''
                    />
                    <img
                        style={{ height: '18px',     width: "50%"}}
                        src={"/images/logo_n2_inbursa.png"}
                        alt=''
                    />
                </>
                :
                <>
                    {
                        !isContainerTelcel &&
                        <img
                            style={{ height: '22.8px', marginRight: "3%", width: "39px", verticalAlign: "middle" }}
                            src={"/images/tarjeta_claro_pay.png"}
                            alt=''
                        />
                    }
                    <img
                    style={{ width: '132px', height: "15.2px", position: 'relative', top: '3px'}}
                    src={"/images/m_todo_cp.png"}
                    alt='' />
                </>                    
            }
            <img
                style={{ width: isContainerTelcel ? '19.2px' : '24px', height: isContainerTelcel ? '19.2px' : '24px', verticalAlign: "middle", float: "right", position: 'relative', top: isContainerTelcel ? '4px' : '0px'}}
                src={(props.selectValue == "claro-pay")?paymentMethodBulletActive:paymentMethodBulletInactive}
                alt=''
            />
        </Option>);
    }
    
    
    

    props.cardItems.map((item, index) => {
        
        let expirationValidate = getExpirationDate(item.card.expirationDate);
        let imageCard = getImageCard(item.card.mark);
        let tokenValidate = false;
        let updateCard = false;

        switch(item.card.tokens.length) {
            case 1:
                tokenValidate = false;
                break;
            case 2:
                tokenValidate = true;
                break;
        }
        //Valores para inhabilitar validaciones de fecha y tokens.
        expirationValidate = true;
        tokenValidate = true;
        if(tokenValidate == false || expirationValidate == false){
            updateCard = true;
        }

        let cardInfoItem = {
            value : item.cardId,
            mark  : item.card.mark,
            type  : item.card.type,
            lastDigits : item.card.lastDigits,
            update: updateCard,
            card: item
        }

        arrayItems.push(
            <Option 
                key={index} 
                onClick={(event) => {handleExecuteTaggeo("Click modal Tarjeta"), props.handleInputClick(event, "cardId", cardInfoItem)}}
                border={(props.selectValue == item.cardId && props.isClaroPartner) ? "1.5px solid #369cf7" : null}
                fontColor = {isContainerTelcel ? "#222222" : undefined}
                fontFamily = {isContainerTelcel ? "AMX-Regular" : undefined} 
                borderRadius={isContainerTelcel ? "4px" : undefined} 
                boxShadow={isContainerTelcel ? "0px 2px 2px 0px #c6c6c6, 0px 2px 2px #fafafa" : undefined} 
                padding={isContainerTelcel ? "18.6px 15.1px 16.2px 13.6px" : undefined}
                role='button'
                aria-label={`Seleccionar pagar con tarjeta terminación` + item.card.lastDigits}
            >
                <img
                    style={{ height: '24px', marginRight: "2%", verticalAlign: "middle" }}
                    src={imageCard}
                    alt=''
                />
                <TextOption aria-hidden="true">{ "****** " + item.card.lastDigits }</TextOption>
                <img style={{ width: isContainerTelcel ? '19.2px' : '24px', height: isContainerTelcel ? '19.2px' : '24px', verticalAlign: "middle", float: "right", position: 'relative', top: isContainerTelcel ? '4px' : '0px'}}
                    src={(props.selectValue == item.cardId)?paymentMethodBulletActive:paymentMethodBulletInactive}
                    alt=''
                />
            </Option>
        )

    });

    const icono_agregar_fondos = props.isClaroPartner 
        ? "/images/icono_icono_agregar_fondos.png"
        : "/images/icono_agregar_fondos.svg";
        
    arrayItems.push(
        <Option 
            key={998} 
            onClick={(event) => {
                if(props.canMultiAnalytics && props.isContainerTelcel) {
                    const originAnalyticArray = props.originAnalytic? props.originAnalytic.split(",") : [];
                    props.executeTaggeo({
                        eventName: "pay_service_or_tae",
                        seccion: "servicios",
                        subseccion: props.serviceInfo && props.serviceInfo.serviceId && getServicesTelcel(props.serviceInfo.serviceId),
                        origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
                        pantalla: "formulario de pago",
                        nombreServicio: props.serviceInfo && props.serviceInfo.serviceName ? props.serviceInfo.serviceName : props.serviceInfo.categoryName,
                        tipoElemento: "card",
                        nombreElemento: "Agregar metodo de pago",
                        trackAction: true,
                    });
                } else {
                    handleExecuteTaggeo("Click modal Agregar método de pago")
                }
                props.handleInputClick(event, "cardId", cardInfoItemAddCard)
            }}
            marginBottom={"7em"}
            fontColor = {isContainerTelcel ? "#222222" : undefined}
            fontFamily = {isContainerTelcel ? "AMX-Regular" : undefined} 
            borderRadius={isContainerTelcel ? "4px" : undefined} 
            boxShadow={isContainerTelcel ? "0px 2px 2px 0px #c6c6c6, 0px 2px 2px #fafafa" : undefined} 
            padding={isContainerTelcel ? "18.6px 15.1px 16.2px 13.6px" : undefined}
            role='button'
            aria-label='Agregar método de pago'
        >
            {
                !isContainerTelcel ?
                <img
                    style={{ height: '24px', width:"42px", marginRight: "2%", verticalAlign: "middle" }}
                    src={"/images/icono_agregar_fondos.svg"}
                    alt=''
                /> :
                <img
                    style={{ height: '27.8px', width:"27.8px", marginRight: "15px", verticalAlign: "middle" }}
                    src={"/images/icon_agregar_pago.png"}
                    alt=''
                />
            }
            
            <TextOption aria-hidden="true">{ "Agregar método de pago" }</TextOption>
            <img style={{ 
                width: isContainerTelcel ? '19.2px' : '24px', 
                height: isContainerTelcel ? '19.2px' : '24px', 
                verticalAlign: "middle", 
                float: "right", 
                position: 'relative', 
                top: isContainerTelcel ? '4px' : '0px', 
                display: isContainerTelcel ? 'block' : 'none'}}
                    src={paymentMethodBulletInactive}
                    alt=''
            />
        </Option>
    );

    const textTitle = !props.isClaroPartner ? "Ahora elige": "Elige un método";
    const textTitleSecondary = !props.isClaroPartner ? "tu método de pago" : "de pago";

    React.useEffect(() => {
        if (props.isOpen && props.isContainerTelcel) {
             if(props.canMultiAnalytics) {
                const originAnalyticArray = props.originAnalytic? props.originAnalytic.split(",") : [];
                props.executeTaggeo({
                        eventName: "pay_service_or_tae",
                        seccion: "servicios",
                        subseccion: props.serviceInfo && props.serviceInfo.serviceId && getServicesTelcel(props.serviceInfo.serviceId),
                        origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
                        pantalla: "formulario de pago",
                        nombreServicio: props.serviceInfo && props.serviceInfo.serviceName ? props.serviceInfo.serviceName : props.serviceInfo.categoryName,
                        tipoElemento: "modal",
                        nombreElemento: "ahora elige tu metodo de pago",
                        trackState: true,
                });
            } else {
                props.executeTaggeo({
                    step: "Formulario de pago",
                    action : "View modal",
                    id_message: "Elige método de pago"
                });
            }
        }
    }, [props.isOpen])

    React.useEffect(() => {
        if (props.isOpen && props.isContainerTelcel) {
            props.executeTaggeo({
                step: "Formulario de pago",
                action : "View modal",
                id_message: "Elige método de pago"
            });
        }
    }, [props.isOpen])

    return (
        <ClaroModalCustom isOpen={props.isOpen} backgroundColor={props.backgroundColor} >
            <ClaroCardSimple 
                backgroundColor={ props.isContainerTelcel ? "#f6f6f6" : '#fff' }
                borderRadius='15px 15px 0px 0px'
                margin='0px'
                height={props.height}
                style={{
                    width:"100%",
                    position: "fixed",
                    bottom: "0px"
                }}
                fadeIn={props.fadeIn}
                fadeInTime={props.fadeInTime}
                cubicBezier={props.cubicBezier}
                addCloseEfect = {props.addCloseEfect}
            >
                <ButtonClose onClick={() => {handleExecuteTaggeo("Click modal Cerrar"), props.closeSelectCardClaroSocio()}}>
                    <img 
                        src={isContainerTelcel ? "/images/icono_salir_contenedor.png" : "/images/icono_salir.svg"}
                        width={isContainerTelcel ? "24" : "16"}
                        height={isContainerTelcel ? "24" : "16"} />
                </ButtonClose>
                <Title
                    fontFamily={isContainerTelcel ? "AMX-Regular" : undefined}
                    fontWeight={isContainerTelcel ? "normal" : undefined}
                    fontColor={isContainerTelcel ? "#222222" : "#000"}
                    fontSize={isContainerTelcel ? "28px" : undefined}>
                    { textTitle } 
                </Title> 
                <Title style={{marginBottom:"10%"}}
                    fontFamily={isContainerTelcel ? "AMX-Regular" : undefined}
                    fontWeight={isContainerTelcel ? "normal" : undefined}
                    fontColor={isContainerTelcel ? "#222222" : "#000"}
                    fontSize={isContainerTelcel ? "28px" : undefined}> 
                    { textTitleSecondary } 
                </Title> 
                <div
                    style={{
                        margin: 'auto',
                        width:"96%",
                        overflow: "scroll",
                        height: "100%"
                    }}
                >
                    {arrayItems}
                    <br />
                    &nbsp;
                </div>
            </ClaroCardSimple>
        </ClaroModalCustom>
    );
}

export default SelectCardClaroSocio;
